<template>
  <image-description-list
    title="common.whatWeDo"
    titleColor="#603813"
    :starIconObj="{ componentName: 'shared', imgName: 'starIconGreen', imgFormat: 'svg' }"
    :starBackgroundLeftObj="{ componentName: 'shared', imgName: 'starGroupIconGreenLeftBig', imgFormat: 'svg', bottom: '0%' }"
    :starBackgroundRightObj="{ componentName: 'shared', imgName: 'starGroupIconGreenRightBig', imgFormat: 'svg', top: '-10%' }"
    :imageDescList="patientsStore.photoDescList"
    labelColor="#488F82"
    descColor="#373F41"
    class="pb-24"
  />
</template>

<script setup lang="ts">
import { usePatientsStore } from "@/stores/patients";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const patientsStore = usePatientsStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>